import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import App from "./routes/router";
import reportWebVitals from "./reportWebVitals";
import { AppContext } from "./Context/AppContext";

console.log("Frontend App is running at:", window.location.origin);
console.log("Frontend is connecting to Backend API Domain:", process.env.REACT_APP_API_DOMAIN);

const theme = createTheme();

function AppWrapper() {
  const [limit, setLimit] = useState("");

  const contextValue = {
    limit,
    setLimit,
  };

  return (
    <AppContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </AppContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <AppWrapper />
  </HelmetProvider>
);

reportWebVitals();
